export function registerCarousel(Alpine) {
    Alpine.data('carousel', () => ({
        page: 0,
        totalPages: 1,
        perPage: 3,
        _container: null,

        init() {
            this._container = this.$el.querySelector('.ik-section-courses__cards');
            this._nav = this.$el.querySelector('.ik-section-courses__nav');
            if (!this._container) return;

            this._setup();
            this._calcPages();

            window.addEventListener('resize', () => {
                this._setup();
                this._calcPages();
                this._go(false);
            }, { passive: true });
        },

        next() {
            this.page = (this.page + 1) % this.totalPages;
            this._go(true);
        },

        prev() {
            this.page = (this.page - 1 + this.totalPages) % this.totalPages;
            this._go(true);
        },

        _setup() {
            const lg = window.matchMedia('(min-width: 992px)').matches;
            if (lg) {
                this._container.style.overflowX = 'hidden';
                this._container.style.justifyContent = 'flex-start';
                // Larghezza esatta per 3 card + 2 gap
                const step = this._cardStep();
                const gap = parseFloat(getComputedStyle(this._container).columnGap) || 24;
                const viewportWidth = (this.perPage * step - gap) + 'px';
                this._container.style.maxWidth = viewportWidth;
                this._container.style.marginInline = 'auto';
                // Allinea frecce con le card
                if (this._nav) {
                    this._nav.style.maxWidth = viewportWidth;
                    this._nav.style.marginInline = 'auto';
                }
            } else {
                this._container.style.overflowX = '';
                this._container.style.justifyContent = '';
                this._container.style.maxWidth = '';
                this._container.style.marginInline = '';
                if (this._nav) {
                    this._nav.style.maxWidth = '';
                    this._nav.style.marginInline = '';
                }
            }
        },

        _go(smooth) {
            if (!this._container) return;
            this._container.scrollTo({
                left: this.page * this.perPage * this._cardStep(),
                behavior: smooth ? 'smooth' : 'instant',
            });
        },

        _cardStep() {
            const card = this._container.querySelector('.ik-course-card');
            if (!card) return 314;
            const gap = parseFloat(getComputedStyle(this._container).columnGap) || 24;
            return card.offsetWidth + gap;
        },

        _calcPages() {
            const total = this._container.querySelectorAll('.ik-course-card').length;
            this.totalPages = Math.max(1, Math.ceil(total / this.perPage));
            if (this.page >= this.totalPages) this.page = 0;
        },
    }));
}
